import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
    requestUserMeta(context) {
        Vue.http.get(
            context.getters.authHandler + '/meta', {
                emulateJSON: true,
                params: {},
                headers: context.getters.secureHeaders
            }
        ).then((umeta) => {
            let userMeta = umeta.body.result ? (umeta.body.data || { favorites: [] }) : { favorites: [] };
            context.commit('updateUserMeta', userMeta)
        });
    }
}